// extracted by mini-css-extract-plugin
module.exports = {"LoadingData":"PeopleTracking_LoadingData__3DKk1","loadMoreButton":"PeopleTracking_loadMoreButton__1L2t3"};